import { defineMessages } from 'react-intl';

export const ProjectInfoMessages = defineMessages({
  projectInfoTitle: {
    id: 'newEstimation.projectBasics.projectInfo.title',
    defaultMessage: 'Start Your Estimator Project',
  },
  projectInfoSubtitle: {
    id: 'newEstimation.projectBasics.projectInfo.subtitle',
    defaultMessage:
      'Please answer a few questions and Estimator will prepare a basic estimation overview for you.',
  },
  projectNameLabel: {
    id: 'newEstimation.projectBasics.projectInfo.projectNameLabel',
    defaultMessage: 'Project Name',
  },
  planningResponsibleLabel: {
    id: 'newEstimation.projectBasics.projectInfo.planningResponsibleLabel',
    defaultMessage: 'Planning Responsible',
  },
  reviewerLabel: {
    id: 'newEstimation.projectBasics.projectInfo.reviewerLabel',
    defaultMessage: 'Reviewer',
  },
  additionalContributorsLabel: {
    id: 'newEstimation.projectBasics.projectInfo.additionalContributorsLabel',
    defaultMessage: 'Project Contributors',
  },
  estimationLanguageLabel: {
    id: 'newEstimation.projectBasics.projectInfo.estimationLanguageLabel',
    defaultMessage: 'Estimation Language ',
  },
  projectTypeLabel: {
    id: 'newEstimation.projectBasics.projectInfo.projectTypeLabel',
    defaultMessage: 'Project Type',
  },
  methodologyLabel: {
    id: 'newEstimation.projectBasics.projectInfo.methodologyLabel',
    defaultMessage: 'Estimation Methodology',
  },
  defaultEstimationUnitLabel: {
    id: 'newEstimation.projectBasics.projectInfo.defaultEstimationUnitLabel',
    defaultMessage: 'Default estimation unit',
  },
  projectDescriptionLabel: {
    id: 'newEstimation.projectBasics.projectInfo.projectDescriptionLabel',
    defaultMessage: 'Project Description',
  },
  projectDescriptionHelpText: {
    id: 'newEstimation.projectBasics.projectInfo.projectDescriptionHelpText',
    defaultMessage: 'Please describe the purpose, scope, and context of the project.',
  },
});
